module.exports = __webpack_public_path__ + "static/media/bg-personal-insurance.d92e1a91.jpg";